<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-公益项目">
    <div class="program">
      <div class="pHeader">
        <div
          class="tBox"
          :style="
            totalData.length - 1 == index
              ? `border-right:none;width:${100 / totalData.length}%`
              : `width:${100 / totalData.length}%`
          "
          v-for="(item, index) in totalData"
          :key="index"
        >
          <div class="oneBox">
            <h3>{{ item.name }}</h3>
            <CountTo
              :usegroup="true"
              :simplify="false"
              :delay="index * 500"
              count-class="count-text"
              unit-class="unit-class"
              :end="item.total"
              :decimals="item.total - parseInt(item.total) == 0 ? 0 : 2"
            ></CountTo>
          </div>
        </div>
      </div>
      <div class="pnav">
        <ul>
          <li
            :style="
              index == nav.length - 1
                ? currentIndex == index
                  ? `background-color:#0687c8;color:#fff;border-right:none;width:calc((100vw - 0.6rem)/${nav.length})`
                  : `border-right:none;width:calc((100vw - 0.6rem)/${nav.length})`
                : currentIndex == index
                ? `background-color:#0687c8;color:#fff;width:calc((100vw - 0.6rem)/${nav.length})`
                : `width:calc((100vw - 0.6rem)/${nav.length})`
            "
            v-for="(item, index) in nav"
            :key="index"
            @click="changNav(item, index)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <!-- <div class="pTitle wow fadeInUp" data-wow-duration="1s">
        <h4>FUNDRAISING PROJECTS</h4>
        <h1>募捐项目</h1>
      </div> -->
      <!-- <div class="pNav wow fadeInUp" data-wow-duration="1s">
        <ul>
          <li
            @click="changNav(item,index)"
            :class="index==currentIndex?'selected':''"
            v-for="(item,index) in nav"
            :key="index"
          >{{item.name}}</li>
        </ul>
        <h4 @click="$router.push('/login')">
          项目申请
          <i class="el-icon-thumb"></i>
        </h4>
      </div> -->
      <div v-if="paginations.total > 0" class="pWrapper">
        <div
          class="oneWrapper"
          v-for="(item, index) in programData"
          :key="index"
        >
          <div class="show">
            <img @click="$router.push(`/mProgramDetail/${item.id}`)" class="showImg" :src="item.picture" alt />
            <img
              class="showIcon"
              :src="
                require('../assets/' +
                  (item.status == 2
                    ? 'start'
                    : item.status == 3
                    ? 'ing'
                    : item.status == 4
                    ? 'end'
                    : '') +
                  '.png')
              "
              alt
            />
          </div>
          <div class="content">
            <h2 @click="$router.push(`/mProgramDetail/${item.id}`)">
              {{ item.name }}
            </h2>
            <div class="tBox">
              <div class="oneBox">
                <h3>已募集资金(元)</h3>
                <CountTo
                  :usegroup="true"
                  :simplify="false"
                  count-class="count-text"
                  unit-class="unit-class"
                  :end="Number(item.raisefund)"
                ></CountTo>
              </div>
              <div class="oneBox">
                <h3>已资助资金(元)</h3>
                <CountTo
                  :usegroup="true"
                  :simplify="false"
                  count-class="count-text"
                  unit-class="unit-class"
                  :end="Number(item.recipients)"
                ></CountTo>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="noProgram" v-else>暂无项目</div>
      <div class="tspage" v-if="paginations.total > paginations.page_size">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="paginations.page_index"
          :page-size="paginations.page_size"
          :total="paginations.total"
          layout="prev, pager, next"
        ></el-pagination>
      </div>
      <div @click="apply" class="someContentBtn">项目申请</div>
    </div>
  </div>
</template>
<script>
import CountTo from "@/components/count-to";
import Bus from "@/utils/bus.js";
import { BASE_URL } from "@/utils/base.js";
import { getProgramList, getAllList } from "@/api/user.js";
import WOW from "wowjs";
export default {
  data() {
    return {
      nav: [
        { name: "全部", status: -1 },
        { name: "募集中", status: 2 },
        { name: "运营中", status: 3 },
        { name: "已结束", status: 4 },
      ],
      totalData: [
        { name: "募捐项目", total: 0 },
        { name: "募捐总额", total: 0 },
        { name: "捐赠人数", total: 0 },
        { name: "受助人数", total: 0 },
      ],
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      // nav: [
      //   { title: "合作模式", url: "hzms" },
      //   { title: "项目捐赠", url: "xmjz" }
      // ],
      currentIndex: 0,
      programData: [],
    };
  },
  mounted() {
    this.$nextTick(function () {
      Bus.$emit("getCurrent", "hzzx");
    });
    this.getProgram();
    this.getAllMoney();
    setTimeout(() => {
      let wow = new WOW.WOW({
        boxClass: "wow",
        animateClass: "animated",
        offset: 0,
        mobile: true,
        live: true,
      });
      wow.init();
    }, 200);
  },
  methods: {
    // 获取项目列表
    async getProgram() {
      let programInfo = new FormData();
      programInfo.append("page", this.paginations.page_index);
      programInfo.append("rows", this.paginations.page_size);
      // programInfo.append("dentity", this.$store.state.user.userInfo.id);
      if (this.keyword) {
        programInfo.append("name", this.keyword);
      }
      programInfo.append("keyword", this.nav[this.currentIndex].status);
      let reg = await getProgramList(programInfo);
      this.paginations.total = reg.total;
      this.programData = reg.rows;
      this.programData.map((item, index) => {
        item.picture = BASE_URL + item.picture;
      });
    },
    // 获取全部统计信息
    async getAllMoney() {
      let money = await getAllList();
      this.totalData[0].total = money.countproject;
      this.totalData[1].total = money.countmoney;
      this.totalData[2].total = money.countdonatenumber;
      this.totalData[3].total = money.countrecipientnumber;
    },
    // 切换项目状态
    changNav(item, index) {
      this.currentIndex = index;
      this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      };
      this.getProgram();
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.getProgram();
    },
    // 项目申请
    apply() {
      this.$message.warning("如果您需要进行项目申请，可以前往电脑端进行操作。");
    },
  },
  components: {
    CountTo,
  },
};
</script>

<style lang="less" scoped>
.main {
  margin-top: 150px;
  width: 100%;
  background-color: #ebebeb;
  padding: 20px 0 80px;

  .program {
    width: calc(100vw - 60px);
    margin: 0 auto;
    .pHeader {
      display: flex;
      margin-bottom: 20px;
      width: 100%;
      height: 74px;
      padding: 13px 0;
      border-radius: 10px;
      background-color: #fff;
      box-shadow: 2px 2px 10px #ddd;
      justify-content: space-between;
      .tBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-right: 1px solid #ebebeb;

        .oneBox {
          width: 100%;
          text-align: center;
          font-size: 22px;
          color: #0687c8;
          h3 {
            color: #333;
            font-size: 26px;
            margin-bottom: 16px;
            font-weight: normal;
          }
        }
      }
    }
    .pnav {
      height: 60px;
      width: 100%;
      margin: 0 auto;
      margin-bottom: 20px;
      background-color: #fff;
      border-radius: 10px;
      overflow: hidden;

      ul {
        display: flex;
        height: 60px;
        justify-content: center;
        li {
          font-size: 30px;
          color: #333;
          height: 60px;
          text-align: center;
          line-height: 60px;
          border-right: 1px solid #cccccc;
          cursor: pointer;
        }
      }
    }
    .pTitle {
      text-align: center;
      h1 {
        font-size: 26px;
        margin-bottom: 60px;
        font-weight: 600;
      }
      h4 {
        margin-top: 80px;
        margin-bottom: 10px;
      }
    }
    .pNav {
      display: flex;
      justify-content: space-between;
      margin-bottom: 30px;
      ul {
        display: flex;
        li {
          height: 30px;
          line-height: 30px;
          font-size: 18px;
          margin-right: 16px;
          cursor: pointer;
          padding: 0 20px;
        }
        .selected {
          color: #ffffff;
          background-color: #0687c8;
          border-radius: 5px;
        }
      }
      h4 {
        width: 120px;
        height: 30px;
        background-color: #0687c8;
        color: #ffffff;
        font-size: 15px;
        text-align: center;
        line-height: 30px;
        border-radius: 5px;
        cursor: pointer;
        i {
          margin-left: 6px;
        }
      }
    }
    .pWrapper {
      width: 100%;
      display: flex;
      flex-direction: column;
      min-height: 300px;

      .oneWrapper {
        width: 100%;
        border-radius: 10px;
        margin-top: 20px;
        overflow: hidden;
        .show {
          width: 100%;
          overflow: hidden;
          position: relative;
          .showImg {
            width: 100%;
            height: 100%;
            border-radius: 10px;
          }
          .showIcon {
            position: absolute;
            width: 240px;
            height: 240px;
            top: -5px;
            right: -50px;
            z-index: 10;
          }
        }
        .content {
          width: 100%;
          background-color: #fff;
          padding: 20px 0;
          h2 {
            width: 85%;
            margin-left: 35px;
            font-weight: 600;
            font-size: 30px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
          .tBox {
            display: flex;
            margin-top: 20px;
            width: 100%;
            height: 74px;
            padding: 13px 0;

            .oneBox {
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border-right: 1px solid #ebebeb;
              width: 50%;
              text-align: center;
              font-size: 26px;
              color: #333;
              h3 {
                color: #333;
                font-size: 26px;
                margin-bottom: 16px;
                font-weight: normal;
              }
            }
          }
        }
      }
    }
    .noProgram {
      margin-top: 60px;
      font-size: 30px;
      text-align: center;
    }
    .tspage {
      margin-top: 40px;
      text-align: center;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #fd7a3a;
        border: none;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #fff; // 进行修改未选中背景和字体
        padding: 0 14px;
        font-size: 26px;
        height: 50px;
        line-height: 50px;
        margin: 0 10px;
        // color: #fff;
      }
      /deep/ .el-pagination.is-background button {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        font-size: 26px;
        height: 50px;
        line-height: 50px;
        padding: 0 10px;
        // color: #fff;
      }
    }
    .someContentBtn {
      margin: 60px auto 0;
      width: 260px;
      height: 70px;
      line-height: 70px;
      font-size: 32px;
      border: 1px solid #000;
      color: #333;
      text-align: center;
      border-radius: 40px;
    }
  }
}
</style>